import { __read } from "tslib";
import { useState } from 'react';
import { randomId } from './random-id';
export var useId = function useId(prefix, props) {
  var idToUse = props.id ? props.id : props.label ? prefix + "-" + props.label : randomId(prefix);

  var _a = __read(useState(idToUse), 1),
      id = _a[0];

  return id;
};